import React, { useState, useEffect } from 'react';
import '../styles/Form.css'; // CSSファイルをインポート
import { useRecaptcha } from '../hooks/useRecaptcha';

const ContactForm = () => {

  const fieldMappings = {
    '00NBV000000PoUo': 'category',     // カテゴリー
    '00NBV000000OGvd': 'sourceLink',   // ソースリンク
    '00NBV000000OGvi': 'ipAddress',    // IPアドレス
    '00NBV000000PoWu': 'consent',         // プライバシーポリシーの同意
    // 他のSalesforceフィールドもここに追加可能
  };


  const [formData, setFormData] = useState({
    name: '',
    email: '',
    category: '',
    company: '',
    phone: '',
    subject: '',
    description: '',
    consent: false,
    ipAddress: '',
    sourceLink: '',
  });

  const [formErrors, setFormErrors] = useState({});
  const [showCompanyFields, setShowCompanyFields] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [recaptchaToken, recaptchaReady] = useRecaptcha();

  useEffect(() => {
    // IPアドレスの取得
    fetch('https://ipinfo.io/json')
      .then(response => response.json())
      .then(data => {
        setFormData(prevData => ({
          ...prevData,
          ipAddress: data.ip,
        }));
        // IPアドレスをフォームの隠しフィールドに設定
        const ipField = document.getElementById('ipAddressField');
        if (ipField) ipField.value = data.ip;
      })
      .catch(error => console.error('Error fetching IP address:', error));

    // ソースリンクの取得
    setFormData(prevData => ({
      ...prevData,
      sourceLink: document.referrer,
    }));
    // ソースリンクをフォームの隠しフィールドに設定
    const sourceLinkField = document.getElementById('sourceLinkField');
    if (sourceLinkField) sourceLinkField.value = document.referrer;
  }, []);

  const handleConsentClick = (e) => {
    e.preventDefault();
    setFormData(prevData => ({
      ...prevData,
      consent: !prevData.consent,  // 現在のチェック状態を反転
    }));
  };


  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const mappedField = fieldMappings[name]; // フィールド名から対応するformDataキーを取得

    // マッピングが存在する場合はformDataの該当フィールドを更新
    if (mappedField) {
      setFormData(prevData => ({
        ...prevData,
        [mappedField]: type === 'checkbox' ? checked : value,
      }));
    } else {
      // マッピングにない一般的なフィールドの処理
      setFormData(prevData => ({
        ...prevData,
        [name]: type === 'checkbox' ? checked : value,
      }));
    }

    // カテゴリーに基づく法人フィールドの表示制御
    if (name === '00NBV000000PoUo' && (value === '法人のお客様' || value === 'メディア関係のお客様')) {
      setShowCompanyFields(true);
    } else if (name === '00NBV000000PoUo') {
      setShowCompanyFields(false);
      setFormData(prevData => ({
        ...prevData,
        company: '',
        phone: '',
      }));
    }
  };


  // フォームのバリデーション処理
  const validateForm = () => {
    let errors = {};
    if (!formData.name) errors.name = 'お名前を入力してください';
    if (!formData.email) errors.email = '正しいメールアドレスを入力してください';
    if (!formData.category) errors.category = 'カテゴリーを選択してください';
    if (!formData.subject) errors.subject = '件名を入力してください';
    if (!formData.description) errors.description = 'お問い合わせ内容を入力してください';

    if (showCompanyFields) {
      if (!formData.company) errors.company = '法人名を入力してください';
      if (!formData.phone) errors.phone = '電話番号を入力してください';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  // プライバシーポリシーのチェックを確認
  const validateConsent = () => {
    let consentError = '';
    if (!formData.consent) {
      consentError = 'ご同意ボタンをチェックしてください';
      setFormErrors(prevErrors => ({
        ...prevErrors,
        consent: consentError,
      }));
    }
    return formData.consent;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const isFormValid = validateForm();
    const isConsentValid = validateConsent();
  
    if (!isFormValid || !isConsentValid) {
      setShowErrorMessage(true);
      return;
    }
  
    if (!recaptchaReady || !recaptchaToken) {
      alert('reCAPTCHAの検証に失敗しました。再度お試しください。');
      return;
    }
  
    try {
      // reCAPTCHA 検証リクエストをサーバーに送信
      const response = await fetch('/wp-admin/admin-ajax.php?action=verify_recaptcha', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          'recaptcha_token': recaptchaToken,
        }),
      });
  
      const result = await response.json();
  
      if (!result.success) {
        alert(result.message || 'reCAPTCHAの検証に失敗しました。');
        return;
      }
  
      // フォーム送信が成功する場合
      setShowErrorMessage(false);
  
      // GTMのcontactFormSubmitトリガーを発火
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'contactFormSubmit',
        formData: {
          name: formData.name,
          email: formData.email,
          category: formData.category,
        },
      });
  
      // フォームを実際に送信
      document.getElementById('contactForm').submit();
  
    } catch (error) {
      alert('reCAPTCHAの検証中にエラーが発生しました。');
    }
  };
  
  
  return (
    <form 
      action="https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8" 
      method="POST" 
      id="contactForm" 
      className="p-form"
      onSubmit={handleSubmit}
    >

      <input type="hidden" name="orgid" value="00D2x0000072gyz" />
      <input type="hidden" name="retURL" value="https://www.eltschool.jp/thankscontact" />
      <input type="hidden" id="00NBV000000OGvd" name="00NBV000000OGvd" value={formData.sourceLink} />
      <input type="hidden" id="00NBV000000OGvi" name="00NBV000000OGvi" value={formData.ipAddress} />
      <input type="hidden" name="external" value="1" />

      <p className={showErrorMessage ? 'notfilled invalid' : 'notfilled'} style={{ display: showErrorMessage ? 'block' : 'none' }}>
        未記入項目があります
      </p>

      <div className="p-form__items">
        <div className={`p-form__item ${formErrors.name ? 'invalid' : ''}`}>
          <label className="p-form__head">お名前<span className="p-form__required">必須</span></label>
          <div className="p-form__body">
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="田中 英悟"
              className={formErrors.name ? 'invalid' : ''}
            />
            {formErrors.name && <span className="error invalid">{formErrors.name}</span>}
          </div>
        </div>

        <div className={`p-form__item ${formErrors.email ? 'invalid' : ''}`}>
          <label className="p-form__head">メールアドレス<span className="p-form__required">必須</span></label>
          <div className="p-form__body">
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="example@email.com"
              className={formErrors.email ? 'invalid' : ''}
            />
            {formErrors.email && <span className="error invalid">{formErrors.email}</span>}
          </div>
        </div>

        <div className={`p-form__item ${formErrors.category ? 'invalid' : ''}`}>
          <label className="p-form__head">カテゴリー<span className="p-form__required">必須</span></label>
          <div className="p-form__body">
            <select
              name="00NBV000000PoUo"
              id="00NBV000000PoUo"
              value={formData.category}
              onChange={handleInputChange}
              className={formErrors.category ? 'invalid' : ''}
            >
              <option value="" hidden>未選択 ▼</option>
              <option value="入会をご検討中のお客様">入会をご検討中のお客様</option>
              <option value="現在ご利用中のお客様">現在ご利用中のお客様</option>
              <option value="法人のお客様">法人のお客様</option>
              <option value="メディア関係のお客様">メディア関係のお客様</option>
              <option value="その他のお客様">その他のお客様</option>
            </select>
            {formErrors.category && <span className="error invalid">{formErrors.category}</span>}
          </div>
        </div>

        {showCompanyFields && (
          <>
            <div className={`p-form__item ${formErrors.company ? 'invalid' : ''}`}>
              <label className="p-form__head">法人名<span className="p-form__required">必須</span></label>
              <div className="p-form__body">
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  className={formErrors.company ? 'invalid' : ''}
                />
                {formErrors.company && <span className="error invalid">{formErrors.company}</span>}
              </div>
            </div>

            <div className={`p-form__item ${formErrors.phone ? 'invalid' : ''}`}>
              <label className="p-form__head">電話番号<span className="p-form__required">必須</span></label>
              <div className="p-form__body">
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className={formErrors.phone ? 'invalid' : ''}
                />
                {formErrors.phone && <span className="error invalid">{formErrors.phone}</span>}
              </div>
            </div>
          </>
        )}

        <div className={`p-form__item ${formErrors.subject ? 'invalid' : ''}`}>
          <label className="p-form__head">件名<span className="p-form__required">必須</span></label>
          <div className="p-form__body">
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleInputChange}
              className={formErrors.subject ? 'invalid' : ''}
            />
            {formErrors.subject && <span className="error invalid">{formErrors.subject}</span>}
          </div>
        </div>

        <div className={`p-form__item ${formErrors.description ? 'invalid' : ''}`}>
          <label className="p-form__head">お問い合わせ内容<span className="p-form__required">必須</span></label>
          <div className="p-form__body">
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              rows="5"
              className={formErrors.description ? 'invalid' : ''}
            ></textarea>
            {formErrors.description && <span className="error invalid">{formErrors.description}</span>}
          </div>
        </div>

        {/* プライバシーポリシーの同意チェックボックス */}
        <div className={`p-form__privacy ${formErrors.consent ? 'invalid' : ''}`}>
          <input
            type="checkbox"
            id="00NBV000000PoWu"
            name="00NBV000000PoWu"
            value="true"
            checked={formData.consent}
            onChange={handleInputChange}
            className="p-form__privacy-check"
          />
          <label htmlFor="00NBV000000PoWu" className="p-form__privacy-label">
            個人情報の取扱について同意する
          </label>
        </div>
        <div className="p-form__privacy-link">
          {/* ラベルの下にリンクを表示 */}
          <a href="https://www.eltschool.jp/policy/" target="_blank" rel="noopener" >
            「個人情報の取扱について」
          </a>
        </div>
        <div className="p-form__privacy-error">
          {/* エラーメッセージをラベルの下に表示 */}
          {formErrors.consent && <span className="error invalid">{formErrors.consent}</span>}
        </div>

        <input type="submit" className="p-form__send" value="送信する" />
      </div>
    </form>
  );
};

export default ContactForm;

